import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ShrinkOutlinedSvg from "@ant-design/icons-svg/es/asn/ShrinkOutlined";
import AntdIcon from "../components/AntdIcon";
var ShrinkOutlined = function ShrinkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShrinkOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ShrinkOutlined.displayName = 'ShrinkOutlined';
}
export default /*#__PURE__*/React.forwardRef(ShrinkOutlined);